import { PHONE_MASK, INN_MASK, KPP_MASK, PHONE_PLACEHOLDER } from "@/consts";
import { useDataFormStore } from "@/stores/form";
import { limitInput } from "@/utils/handleChangeForm";
import { getNameOrganization } from "@/utils/getDataForm";
import { NEWEST_BACKEND } from "@/remotes";
import { ref, onMounted, watch } from "vue";
import { useDataFormStoreApi } from "@/stores/formSave";
import { debounce } from 'lodash';
import { checkCityRoadTo, checkCityRoadFrom } from "@/utils/baseFunctions";
import {
  blockPickupSwitch,
  checkStorage
} from "@/utils/baseFunctions";
import { refreshTimePickup, refreshTimePickupDelivery } from "@/utils/refreshPackages";
import { tabRefreshTimePickup, tabRefreshTimePickupDelivery } from "@/utils/tabsFunctions";
import { computed } from 'vue'

export default {
  props: {
    citiesFrom: Array,
    citiesTo: Array,
    officesFrom: Array,
    officesTo: Array,
  },

  setup() {

    const dataForm = useDataFormStore();
    const dataFormApi = useDataFormStoreApi();

    const isMoscowCity = computed(() => {
        return (dataForm.consignee?.cityTo).includes("(Москва)");
    })
    const moscowApply = () => {
        if(isMoscowCity.value) {
            dataForm.consignee.innConsignee = "9714053621"
            dataForm.consignee.phoneConsignee = "79222302111"
            dataForm.consignee.emailConsignee = "marketplace@tk-luch.ru"
            dataForm.consignee.name = 'ООО "ВАЙЛДБЕРРИЗ"'
            dataForm.consignee.consigneeType = true;
            dataForm.applicationCargoPickup.adressDetailRequiredTo = true;
            dataForm.applicationCargoPickup.addressCargoPickupNoticeTo = "WILDBERRIES";
            dataForm.cargoInformation.cargoSpaceType = "detailed"

            for (const tabKey in dataForm.cargoSpaceTabs) {
              const tab = dataForm.cargoSpaceTabs[tabKey]
              const w = Number(tab.cargoWeight)
              if (w < 50) tab.cargoWeight = 50
              else if (w > 300) tab.cargoWeight = 300
            }

            const w = Number(dataForm.cargoInformation.cargoWeight)
            if (w < 50) dataForm.cargoInformation.cargoWeight = 50
            else if (w > 300) dataForm.cargoInformation.cargoWeight = 300

        } else {
            dataForm.consignee.innConsignee = ""
            dataForm.consignee.phoneConsignee = ""
            dataForm.consignee.emailConsignee = ""
            dataForm.consignee.name = ""
              
            if(dataForm.applicationCargoPickup  && dataForm.applicationCargoPickup.addressCargoPickupNoticeTo == "WILDBERRIES") {
                dataForm.applicationCargoPickup.addressCargoPickupNoticeTo = "";
            }
        }
    }

    // Первый заход
    if((dataForm.consignee?.cityTo).includes("(Москва)")) moscowApply();

    watch(isMoscowCity, moscowApply)

    const options = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];

    const citiesFrom = ref([]);
    const citiesTo = ref([]);

    const officesFrom = ref([]);
    const officesTo = ref([]);
    
    onMounted(async function () {
      try {

        const { data } = await NEWEST_BACKEND.get('/public/cities')

        dataForm.cityDataFrom.value = data;

        data.forEach(element => { 
          citiesFrom.value[element['title']] = {
            id: element['id'],
            name: element['title']
          }; 
        });

        if (dataForm.sender.cityFrom != "") {
          hanlerCityFrom();
        }
    
        
      } catch (e) {
        console.log(e);
      }
    });

    onMounted(async function () {
      try {
        const { data } = await NEWEST_BACKEND.get('/public/cities')

        dataForm.cityDataTo.value = data;

        

        data.forEach(element => { 
          citiesTo.value[element['title']] = {
            id: element['id'],
            name: element['title']
          }; 
        });

        if (dataForm.consignee.cityTo != "") {
          hanlerCityTo();
        }
      } catch (e) {
        console.log(e);
      }
    });

    function changeOfficeTo(_, index) {
      if(!isNaN(index)) {
        dataFormApi.officeToAddress = officesTo[index]
      }
    }

    async function refreshCityRestrictions(type) {

      let cityName = (type == "from") ? dataForm.sender.cityFrom : dataForm.consignee.cityTo;

      let city = (type == "from") ? citiesFrom.value[cityName].id : citiesTo.value[cityName].id


      let config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      // Запрос на упаковки
      try {
        const { data } = await NEWEST_BACKEND.get(`/public/storage/`+city, config);

        if (data) {
          if (type == "from") {
            dataForm.restrictions.maxCargoUnitWeightFrom = data.maxCargoUnitWeight
            dataForm.restrictions.stockWeightFrom = data.maxAcceptanceShippingWeight;
            dataForm.restrictions.stockSizeFrom = data.maxAcceptanceShippingSize;
            dataForm.restrictions.stockHeightFrom = data.maxAcceptanceShippingHeight;
          } else {
            dataForm.restrictions.maxCargoUnitWeightTo = data.maxCargoUnitWeight
            dataForm.restrictions.stockWeightTo = data.maxAcceptanceShippingWeight;
            dataForm.restrictions.stockSizeTo = data.maxAcceptanceShippingSize;
            dataForm.restrictions.stockHeightTo = data.maxAcceptanceShippingHeight;
          }

          dataForm.restrictions.weightUnit = (dataForm.restrictions.maxCargoUnitWeightFrom < dataForm.restrictions.maxCargoUnitWeightTo) ? dataForm.restrictions.maxCargoUnitWeightFrom : dataForm.restrictions.maxCargoUnitWeightTo;

          dataForm.restrictions.weight = (dataForm.restrictions.stockWeightFrom < dataForm.restrictions.stockWeightTo) ? dataForm.restrictions.stockWeightFrom : dataForm.restrictions.stockWeightTo;
          dataForm.restrictions.size = (dataForm.restrictions.stockSizeFrom < dataForm.restrictions.stockSizeTo) ? dataForm.restrictions.stockSizeFrom : dataForm.restrictions.stockSizeTo;
          dataForm.restrictions.height = (dataForm.restrictions.stockHeightFrom < dataForm.restrictions.stockHeightTo) ? dataForm.restrictions.stockHeightFrom : dataForm.restrictions.stockHeightTo;
        }

      } catch (e) {
        console.log(e);
      }
    }

    async function hanlerCityFrom() {
      dataForm.applicationCargoPickup.addressSelected = false;

      if(dataForm.cargoInformation.cargoSpaceType == 'simple') {
        refreshTimePickup();
        refreshTimePickupDelivery();
      } else {
        tabRefreshTimePickup();
        tabRefreshTimePickupDelivery();
      }

      refreshCityRestrictions("from");

      hanlerOffice('cityFrom', 'from');

      // if ((dataForm.sender.cityFrom === "Челябинск" ||
      // dataForm.sender.cityFrom === "Екатеринбург")) {
      //   dataForm.applicationTimeIsOver = '15:00'
      // }
      // else if(dataForm.applicationTimeIsOver === '15:00') {
      //   dataForm.applicationTimeIsOver = '13:00'
      // }
      
      dataForm.updateApplicationTimeIsOver()
    }

    let cargoTypes = {
      'Стандарт' : 1,
      'Цилиндры' : 2,
      'Шины' : 3,
    }

    const suitableLoad = async (key, type, config) => {
      try {
        let config_data = {
          headers: config['headers']
        }
        
        const { data } = await NEWEST_BACKEND.post(`/public/suitable-offices`, config['data'], config_data)

        if(type == "from") { 

          officesFrom.value = data;

          officesFrom.value = officesFrom.value.map((office)=>{
            let addressArr = office.address.split(',');
            let addressCut = "";
            if(office.address.includes("сектор")) {
              addressCut = addressArr.slice(Math.max(addressArr.length - 3, 0)).join(',');
            } else addressCut = addressArr.slice(Math.max(addressArr.length - 2, 0)).join(',');

            let newOffice = Object.assign({}, office, { address: addressCut });
            return newOffice;
          }); 

          dataForm.events.requestEnd = false;

          dataForm.sender.officeFromEmpty = officesFrom.value.length == 0;

          if (dataForm.sender.officeFrom.id) {
            dataForm.sender.officeFromRefuse = officesFrom.value.filter((office) => dataForm.sender.officeFrom.id == office.id).length == 0;
          }   

          // При едином варианте склада делаем его автоматический выбор
          if ((officesFrom.value.length == 1) && (key == 'cityFrom')) {
            
            dataForm.sender.officeFrom = officesFrom.value[0];
          }
          
        } else  {
          officesTo.value = data;

          officesTo.value = officesTo.value.map((office)=>{
            let addressArr = office.address.split(',');
            let addressCut = "";
            if(office.address.includes("сектор")) {
              addressCut = addressArr.slice(Math.max(addressArr.length - 3, 0)).join(',');
            } else addressCut = addressArr.slice(Math.max(addressArr.length - 2, 0)).join(',');

            let newOffice = Object.assign({}, office, { address: addressCut });
            return newOffice;
          }); 

          dataForm.consignee.officeToEmpty = officesTo.value.length == 0;
          if (dataForm.consignee.officeTo.id) {
            dataForm.consignee.officeToRefuse = officesTo.value.filter((office) => dataForm.consignee.officeTo.id == office.id).length == 0;
          }          

          // При едином варианте склада делаем его автоматический выбор
          if ((officesTo.value.length == 1) && (key == 'cityTo')) {
            dataForm.consignee.officeTo = officesTo.value[0];
          }
        }
        
      } catch (e) {
        console.log(e);
      }
    }

    const suitableLoadDebounceFrom = debounce(suitableLoad, 500);
    const suitableLoadDebounceTo = debounce(suitableLoad, 500);

    // Функиця для отслеживания изменения склада в пункте "От"
    async function hanlerOffice(key, type = undefined) {
 
      // if(type == "from") officesFrom.value = []; else officesTo.value = [];

      if(key == 'cityFrom') dataForm.sender.officeFrom = '';
      if(key == 'cityTo') dataForm.consignee.officeTo = '';

      // Получаем город и проверяем на пустоту
      let cityName = (type == "from") ? dataForm.sender.cityFrom : dataForm.consignee.cityTo;

      if( !cityName ||
        (dataForm.cargoInformation.cargoWeight == '') ||
        
        (dataForm.cargoInformation.numberOfIdenticalLoads == '')
      ) return;

      if( (dataForm.cargoInformation.cargoWeight == 0) ||
        
        (dataForm.cargoInformation.numberOfIdenticalLoads == 0)
      ) return;

      // собираем POST параметры
      let param = {};
      param['cityId'] = (type == "from") ? citiesFrom.value[cityName].id : citiesTo.value[cityName].id;
      param['acceptanceCargo'] = type == "from";
      param['IssuanceOfCargo'] = type == "to";

      let cargoes = [];

      // Если обьедененные места
      if (dataForm.cargoInformation.cargoSpaceType == 'simple') {

        cargoes = [];

        // Обрываем функцию если нечего считать
        if(isNaN(dataForm.cargoInformation.numberOfIdenticalLoads) || dataForm.cargoInformation.numberOfIdenticalLoads == '') return;

        for (let i = 0; i < dataForm.cargoInformation.numberOfIdenticalLoads; i++) {

          switch (cargoTypes[dataForm.cargoInformation.typeOfCargo]) {
            case 1:
              cargoes.push({
                "cargoType": cargoTypes[dataForm.cargoInformation.typeOfCargo],
                "weight": parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'))/dataForm.cargoInformation.numberOfIdenticalLoads,
                "width": Math.round(parseFloat(dataForm.cargoInformation.cargoDimensions.width)),
                "height": Math.round(parseFloat(dataForm.cargoInformation.cargoDimensions.height)),
                "length": Math.round(parseFloat(dataForm.cargoInformation.cargoDimensions.length))
              })
              break;
            case 2:
              cargoes.push({
                "cargoType": cargoTypes[dataForm.cargoInformation.typeOfCargo],
                "weight": parseFloat(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'))/dataForm.cargoInformation.numberOfIdenticalLoads,
                "height": Math.round(parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.height)),
                "diameter": Math.round(parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.diameter))
              })
              break;
            case 3:
              cargoes.push({
                "cargoType": cargoTypes[dataForm.cargoInformation.typeOfCargo],
              })
              break;
          }
          
        }

        param['cargoes'] = cargoes;

      } else {
        cargoes = [];

        // Складываем вес посылок чтобы посчитать ограничения в зависимости от типа посылки
        dataForm.cargoSpaceTabs.forEach(tab => {

          switch (cargoTypes[tab.typeOfCargo]) {
            case 1:
              cargoes.push({
                "cargoType":  cargoTypes[tab.typeOfCargo],
                "weight":     parseFloat(tab.cargoWeight.toString().replace(/,/g, '.')),
                "width":      Math.round(parseFloat(tab.width)),
                "height":     Math.round(parseFloat(tab.height)),
                "length":     Math.round(parseFloat(tab.length)),
              })
              break;
            case 2:
              cargoes.push({
                "cargoType":  cargoTypes[tab.typeOfCargo],
                "weight":     parseFloat(tab.cargoWeight.toString().replace(/,/g, '.')),
                "height":     Math.round(parseFloat(tab.height)),
                "diameter":   Math.round(parseFloat(tab.diameter)),
              })
              break;
            case 3:
              cargoes.push({
                "cargoType": cargoTypes[tab.typeOfCargo],
              })
              break;
          }

        });

        param['cargoes'] = cargoes;

      }

      
      

      // Подготовка параметров
      let config = {
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(param),
      }

      // Отправка запроса
      if((key == 'cityFrom') || (key == 'cityTo')) {
        suitableLoad(key, type, config)
      } else {
        if (type == "from") {
          suitableLoadDebounceFrom(key, type, config);
        } else if (type == "to") {
          suitableLoadDebounceTo(key, type, config);
        }
        
      }
    }

    const handleOfficeUpdateDebounce = debounce(() => {
      hanlerOffice('', 'from');
      hanlerOffice('', 'to');
    }, 200)

    watch(dataForm.events , () => {
      if(!dataForm.events.selecting) {handleOfficeUpdateDebounce()}
    });

    watch(dataForm.cargoInformation , () => {
      if(!dataForm.events.selecting) handleOfficeUpdateDebounce()
    });

    watch(dataForm.cargoSpaceTabs, () => { 
      if(!dataForm.events.selecting) handleOfficeUpdateDebounce()
    });
    
    watch(dataForm.applicationCargoPickup, () => {
      if(!dataForm.events.selecting) handleOfficeUpdateDebounce()
    });
    
    function hanlerCityTo() {

      dataForm.applicationCargoPickup.addressSelectedTo = false;

      refreshCityRestrictions("to");

      hanlerOffice('cityTo', 'to');

      if(dataForm.cargoInformation.cargoSpaceType == 'simple') {
        refreshTimePickup();
        refreshTimePickupDelivery();
      } else {
        tabRefreshTimePickup();
        tabRefreshTimePickupDelivery();
      }
      
    }

    return {
      dataForm,
      
      dataFormApi,
      options,
      PHONE_MASK,
      checkCityRoadTo,
      checkCityRoadFrom,
      INN_MASK,
      KPP_MASK,
      officesFrom,
      officesTo,
      changeOfficeTo,
      PHONE_PLACEHOLDER,
      limitInput,
      getNameOrganization,
      hanlerCityFrom,
      isMoscowCity,
      hanlerCityTo,
      randomAutocomplete() {
        return Math.random().toString(36).substring(2, 15)
      },
      cargoPickupSwitchTo(){
        return blockPickupSwitch('to')
      },
      cargoPickupSwitchFrom() {
        return blockPickupSwitch('from');
      },
      checkStorageFrom(){
        return checkStorage('from');
      },
      officeFromShow(){
        return(
          !(
            dataForm.sender.cityFrom == '' ||
            dataForm.sender.officeFromEmpty ||
            dataForm.applicationCargoPickup.isCargoPickup
          )
        );
      },
      officeToShow(){
        return(
          !(
            dataForm.consignee.cityTo == '' ||
            dataForm.consignee.officeToEmpty ||
            dataForm.applicationCargoPickup.deliveryToTheAddress
          )
        );
      },
      checkStorageTo(){
        return checkStorage('to');
      },

      checkPhone: function () {
        if (dataForm.consignee.phoneConsignee === dataForm.sender.phoneSender) {
          dataForm.sender.emailSender = dataForm.consignee.emailConsignee 
          dataForm.sender.firstNameSender = dataForm.consignee.firstNameConsignee 
          dataForm.sender.secondNameSender = dataForm.consignee.secondNameConsignee 
          dataForm.sender.surnameSender = dataForm.consignee.surnameConsignee 
          dataForm.sender.innSender = dataForm.consignee.innConsignee 
          dataForm.sender.name = dataForm.consignee.name 
        }
      },
    };
  },
};
